/** Anything the server reports a user as: `/users`, `/users/{id}`, `{art,team,solution_train}/{id}/members`. */
type ServerUser = { name?: string | null; email?: string | null };

/**
 * What to show as a user's name.
 *
 * A user added by email alone never gets a name: the auth server creates them
 * with an empty FusionAuth `fullName` and every read path reports that back as
 * `name: ""`. The email's local part stands in for it, so those users are not
 * nameless rows across the app.
 */
export function displayUserName(user: ServerUser | null | undefined): string {
  if (!user) return "";
  const email = user.email ?? "";
  const at = email.indexOf("@");
  return user.name || (at > 0 ? email.slice(0, at) : "");
}
